// Libs
import React from "react";
import { useQueryParams, StringParam } from "use-query-params";

// Components
import QuickFilter from "./quickFilters/QuickFilter";
import SortBy from "./SortBy";

// Images
import crownPremium from "../../images/crown-premium.svg";
import iconUS from "../../images/icon-us.svg";
import iconEU from "../../images/icon-eu.svg";
import iconFastShipping from "../../images/icon-fast-shipping.svg";
import iconShippingUnder5 from "../../images/icon-shipping-under-5.svg";

// Style
import { Container, Filters, MoreAction } from "./QuickFiltersStyle.js";

// i18n
import { useTranslation } from 'react-i18next';

const QuickFilters = () => {
  const { t } = useTranslation();
  const [query, setQuery] = useQueryParams({
    premium: StringParam,
    free_usa_shipping: StringParam,
    origin_usa: StringParam,
    ships_from: StringParam,
    shipping_time: StringParam,
    shipping_under: StringParam
  });

  const { shipping_time, shipping_under, ships_from, premium } = query;

  const updateBooleanQuery = (key, event) => {
    setQuery({ ...query, [key]: event.target.checked ? true : null }, "pushIn");
  };

  const updateValueQuery = (key, event, value) => {
    setQuery(
      {
        ...query,
        [key]: event.target.checked ? value : null
      },
      "pushIn"
    );
  };

  const isChecked = queryParam => queryParam === "true";

  return (
    <Container>
      <Filters>
        <QuickFilter
          checked={ships_from === "united-states"}
          onChange={e => updateValueQuery("ships_from", e, "united-states")}
          className="intercom__quick-filter__united-states"
        >
          <img src={iconUS} alt="us flag" /> { t("QuickFilters.Label.ShipsFromUSA") }
        </QuickFilter>
        <QuickFilter
          checked={ships_from === "Europe"}
          onChange={e => updateValueQuery("ships_from", e, "Europe")}
          className="intercom__quick-filter__europe"
        >
          <img src={iconEU} alt="eu flag" /> { t("QuickFilters.Label.ShipsFromEU") }
        </QuickFilter>
        <QuickFilter
          checked={isChecked(premium)}
          onChange={e => updateBooleanQuery("premium", e)}
          className="intercom__quick-filter__premium"
        >
          <img src={crownPremium} alt="Crow" /> { t("QuickFilters.Label.Premium") }
        </QuickFilter>
        <QuickFilter
          checked={shipping_time === "1"}
          onChange={e => updateValueQuery("shipping_time", e, "1")}
          className="intercom__quick-filter__shipping-time"
        >
          <img src={iconFastShipping} alt="truck" /> { t("QuickFilters.Label.FastUSAShipping") }
        </QuickFilter>
        <QuickFilter
          checked={shipping_under === "5"}
          onChange={e => updateValueQuery("shipping_under", e, "5")}
          className="intercom__quick-filter__shipping_under"
        >
          <img src={iconShippingUnder5} alt="coin with arrow down" /> { t("QuickFilters.Label.Under5") }
        </QuickFilter>
      </Filters>
      <MoreAction>
        <SortBy />
      </MoreAction>
    </Container>
  );
};

export default QuickFilters;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/QuickFilters.js